import { Box, Icon, Image, OsModal } from "@outschool/backpack";
import { faCheck } from "@outschool/icons";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { browseRootPath } from "@outschool/routes";
import {
  AuthTriggerActionTypes,
  WelcomeModalData,
  useLoginFlowContext,
} from "@outschool/ui-auth";
import { TrackedButton } from "@outschool/ui-components-shared";
import React from "react";

import rocketHeadImage from "../../images/rocket-head.png";
import Link from "./Link";

export const WELCOME_MODAL_MESSAGE = {
  [AuthTriggerActionTypes.SAVE_AFTER_LOGIN]: (
    _data: WelcomeModalData[AuthTriggerActionTypes.SAVE_AFTER_LOGIN],
  ) => `Your class was saved to your "Favorites"`,
  [AuthTriggerActionTypes.SAVE_SEARCH_AFTER_LOGIN]: (
    _data: WelcomeModalData[AuthTriggerActionTypes.SAVE_SEARCH_AFTER_LOGIN],
  ) => `Your search was saved to your "Favorites"`,
  [AuthTriggerActionTypes.MARK_HELPFUL_AFTER_LOGIN]: (
    _data: WelcomeModalData[AuthTriggerActionTypes.MARK_HELPFUL_AFTER_LOGIN],
  ) => `The review was marked as helpful`,
  [AuthTriggerActionTypes.FOLLOW_AFTER_LOGIN]: (
    data: WelcomeModalData[AuthTriggerActionTypes.FOLLOW_AFTER_LOGIN],
  ) => `You are now following ${data.leaderName}`,
};

export default function WelcomeModal() {
  const {
    isWelcomeModalOpen,
    closeWelcomeModal,
    postLoginActionType,
    welcomeModalData,
    authTrigger,
  } = useLoginFlowContext();

  const welcomeFlashMessage =
    !!postLoginActionType &&
    WELCOME_MODAL_MESSAGE.hasOwnProperty(postLoginActionType) &&
    Boolean(welcomeModalData)
      ? // @ts-ignore
        WELCOME_MODAL_MESSAGE[postLoginActionType](welcomeModalData)
      : undefined;

  const onClose = React.useCallback(() => {
    if (isWelcomeModalOpen) {
      closeWelcomeModal();
      document.body.style.overflow = "auto";
    }
  }, [isWelcomeModalOpen, closeWelcomeModal]);

  return (
    <OsModal
      open={isWelcomeModalOpen}
      onClose={onClose}
      title="Welcome to Outschool!"
      modalDesktopWidth={450}
      actionPrimary={
        <TrackedButton
          variant="contained"
          component={Link}
          to={browseRootPath()}
          onClick={onClose}
          trackingName="welcome-modal-cta"
          trackingSharedProperties={{ authTrigger }}
        >
          See Your Class Suggestions
        </TrackedButton>
      }
    >
      <Box
        sx={{
          display: "grid",
          gridRowGap: "2em",
          justifyItems: "center",
        }}
      >
        {/* eslint-disable-next-line jsx-no-leaked-values/jsx-no-leaked-values */}
        {welcomeFlashMessage && (
          <Box
            sx={{
              backgroundColor: "rgba(41, 168, 119, 0.1)",
              borderColor: "rgba(41, 168, 119, 0.3)",
              color: "#29a877",
              border: "1px solid",
              borderRadius: 4,
              justifySelf: "stretch",
              textAlign: "center",
              padding: "0.5em",
            }}
          >
            <Icon icon={faCheck} />
            &nbsp; {welcomeFlashMessage}
          </Box>
        )}
        <Image
          sx={{
            width: "50%",
          }}
          src={rocketHeadImage}
        />
      </Box>
    </OsModal>
  );
}
